import React from 'react';
import TR from '../../Trans';

function TrackCreators(props) {

  const concatA = (list) => {
let concat = "";
    for (let i = 0; i < list.length; i++) {
      concat += list[i];
      if (i < list.length - 1) {
        concat += ", ";
      }
    }
    return concat;
  };

  const concatB = (list) => {
let concat = "";
    for (let i = 0; i < list.length; i++) {
      concat += list[i];
      if (i < list.length - 1) {
        concat += " ";
      }
    }
    return concat;
  };

  const renderAuthors = (list) => {
if (list.length > 0) {
      return <p className="muvika-creators-p">
        {TR.cm_lyrics_by}: {concatA(list)}
      </p>;
    }
  };

  const renderComposers = (list) => {
if (list.length > 0) {
      return <p className="muvika-creators-p">
        {TR.cm_composed_by}: {concatA(list)}
      </p>;
    }
  };

  const renderPublishers = (list) => {
if (list.length > 0) {
      return <p className="muvika-creators-p">
        {TR.cm_published_by}: {concatB(list)}
      </p>;
    }
  };

  const renderCreators = () => { 
    if (props.creators) {
      let authors = [];
      let composers = [];
      let publishers = [];
      props.creators.forEach((creator) => {
    
switch (creator.role) {
          case "A":
            authors.push(creator.name);
            break;
          case "C":
            composers.push(creator.name);
            break;
          case "E":
            publishers.push(creator.name);
            break;
        }
      });
      return <div>
        {renderAuthors(authors)}
        {renderComposers(composers)}
        {renderPublishers(publishers)}
      </div>;
    }
  };

  return (
    <div>
      {renderCreators()}
    </div>
  );
}

export default TrackCreators;